module.exports = __webpack_public_path__ + "static/media/thumbnail.12f65f6c.jpg";